<template>
  <div class="bottom-header">
    <div class="bottom-header-padding">
      <div
        class="header-select"
        @click="selectBottomChange(k)"
        v-for="(s, k) in bottomData"
        :key="k"
      >
        <div class="select">
          <img :src="k == currentIndex ? s.activeImage : s.image" alt="" />
          <span
            :style="currentIndex == k ? 'color: #bc8a29;' : 'color:#9F8F70;'"
            >{{ s.text }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomHeaderView",
  props: {
    currentIndex: Number,
  },
  data() {
    return {
      bottomData: [
        {
          image: "/static/bottomIcon/home.png",
          activeImage: "/static/bottomIcon/home-active.png",
          text: "首页",
        },
        {
          image: "/static/bottomIcon/history.png",
          activeImage: "/static/bottomIcon/history-active.png",
          text: "历史地图",
        },
        {
          image: "/static/bottomIcon/Initiative.png",
          activeImage: "/static/bottomIcon/Initiative-active.png",
          text: "一带一路",
        },
        {
          image: "/static/bottomIcon/exhibit.png",
          activeImage: "/static/bottomIcon/exhibit-active.png",
          text: "展览",
        },
        {
          image: "/static/bottomIcon/mine.png",
          activeImage: "/static/bottomIcon/mine-active.png",
          text: "我的",
        },
      ],
    };
  },
  methods: {
    selectBottomChange(k) {
      let targetRoute;
      if (k === 0) {
        targetRoute = "/";
      } else if (k === 4) {
        targetRoute = "mine";
      } else if (k === 3) {
        targetRoute = "exhibit";
      } else if (k === 2) {
        targetRoute = "map";
      } else if (k === 1) {
        targetRoute = "historyMap";
      }

      if (targetRoute) {
        const resolved = this.$router.resolve(targetRoute);
        if (this.$route.path!== resolved.route.path) {
          this.$router.push(targetRoute);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom-header {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 99;
  background: #fffdec;
  border-top: 1px solid rgba(209, 196, 166, 0.27);
  .bottom-header-padding {
    padding-top: 0.375rem;
    padding-bottom: 0;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-select {
      width: calc(100% / 5);
      &:nth-last-child(2) {
        .select {
          img {
            height: 1.4063rem;
          }
        }
      }
      &:nth-last-child(3) {
        .select {
          img {
            width: 1.625rem;
            height: 1.5rem;
          }
        }
      }
      &:nth-last-child(4) {
        .select {
          img {
            width: 1.875rem;
            height: 1.4063rem;
          }
        }
      }
    }
    .select {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 1.5625rem;
        height: 1.5625rem;
        margin-bottom: 0.2813rem;
      }
      text {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 0.875rem;
      }
    }
  }
}
</style>

<style>
body {
  background: #fffdec;
}
</style>